export const projects = [
    {
      title: "Crypto Craze",
      subtitle: "Python, Flask, JavaScript, & React",
      description:
        "Deployed a crypto wallet app for viewing the blockchain and account balances, initiating transactions, and mining coin.",
      image: "cryptocurrency.png",
      link: "https://github.com/mjschwarz/cryptocurrency-app",
    },
    {
      title: "Pathfinding Visualization GUI",
      subtitle: "Python and Pygame",
      description:
        "Designed an interactive GUI application in which users place obstacles, select endpoints, and trace search paths using A*, BFS, and DFS algorithms.",
      image: "pathfinder.png",
      link: "https://github.com/mjschwarz/pathfinding-visualization-gui",
    },
    {
      title: "Snake AI GUI",
      subtitle: "Python, PyTorch, & Pygame",
      description:
        "Implemented a Q-learning deep neural network using PyTorch, training the AI to reach scores of 60+ points.",
      image: "snakeai.png",
      link: "https://github.com/mjschwarz/snake-ai-gui",
    },
    {
      title: "Galactic Showdown",
      subtitle: "C#, Unity, & Photon",
      description:
        "Created a laser tag VR game that supports real-time networking for up to four players",
      image: "lasertag.png",
      link: "https://github.com/mjschwarz/laser-tag-vr",
    },
  ];

  export const skills = ["Python", "Inspect AI", "C/C++", "MCP", "Java", "Kubernetes", "SQL", "Kafka","JavaScript", "React"]

  export const experiences = [
    { 
      company: "Walmart Global Technology",
      name: "Software Engineer II",
      bullet1: "Deployed a pipeline to identify items needing substitutes, avoiding over $600,000 in lost sales and saving over 2,000 weekly merchant workhours in the first 3 months after launch",
      bullet2: "Developed key features for an industry-leading AI evaluation framework, increasing test coverage of agentic capabilities to over 80% and decreasing developer testing time from 1-2 hours per deployment to several minutes",
      bullet3: "Spearheaded an initiative to add hundreds of business-performance metrics to Wally, an AI agent focused on streamlining merchant’s day-to-day tasks, reducing merchants’ time spend per metric from 3 minutes to 30 seconds",
      bullet4: "",
      image: "walmart.png",
    },
    { 
      company: "Walmart Global Technology",
      name: "Software Engineer Intern",
      bullet1: "Identified a business need for more rigorous e-commerce analytics through discussions with primary stakeholders",
      bullet2: "Built a dashboard using Python and PostgreSQL, improving merchants' ability to analyze site performance",
      bullet3: "Enhanced algorithms for three key performance indicators, increasing insight into actionable business opportunities",
      bullet4: "",
      image: "walmart.png",
    }, 
    { 
      company: "Ricoh USA",
      name: "Software Engineer Intern",
      bullet1: "Developed programs to populate customer bundles with the latest versions of software, reducing manual error",
      bullet2: "Streamlined project setup workflows using Groovy scripting to automate repetitive version control tasks",
      bullet3: "Created automated testing builds using Jenkins, decreasing manual testing time per release by weeks",
      bullet4: "",
      image: "ricoh.png",
    }, 
    { 
      company: "Active Galactic Nuclei",
      name: "Research Assistant",
      bullet1: "Collaborated with four team members in studying super-massive black hole phenomena",
      bullet2: "Analyzed spectral data sets of quasar observations by writing Python programs to perform curve fitting",
      bullet3: "Generated spectral decomposition plots and other reports using specialized scientific packages",
      bullet4: "",
      image: "agn.jpeg",
      }, 
  ];